import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth';

const commitDate = __APP_COMMIT_DATE__ ? new Date(__APP_COMMIT_DATE__) : null;

export function Shell() {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === 'admin';
  return (
    <div className="shell">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true" />
          <span>
            Insurance Import
            <span className="brand-sub">Admin</span>
          </span>
        </div>
        <nav aria-label="Main">
          <NavLink to="/batches">Batches</NavLink>
          <div className="nav-group">Analytics</div>
          <NavLink to="/analytics" className={({ isActive }) => (isActive ? 'active sub' : 'sub')}>
            Overview
          </NavLink>
          <NavLink to="/destinations">Destinations</NavLink>
          {isAdmin && <NavLink to="/users">Users</NavLink>}
          {isAdmin && (
            <>
              <div className="nav-group">Settings</div>
              <NavLink to="/settings/blob" className={({ isActive }) => (isActive ? 'active sub' : 'sub')}>
                Blob storage
              </NavLink>
              <NavLink to="/settings/cosmos" className={({ isActive }) => (isActive ? 'active sub' : 'sub')}>
                DataHub (Cosmos)
              </NavLink>
              <NavLink to="/settings/llm" className={({ isActive }) => (isActive ? 'active sub' : 'sub')}>
                AI / LLM
              </NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-version" title={commitDate ? `Last commit ${commitDate.toLocaleString()}` : undefined}>
          v{__APP_VERSION__}
          {commitDate && <> · {commitDate.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</>}
        </div>
      </aside>
      <div className="main-col">
        <header className="topbar">
          <div className="spacer" />
          {user && (
            <div className="whoami">
              <span className="whoami-name">{user.name}</span>
              <span className="muted small">{user.email}</span>
              <span className={`role role-${user.role}`}>{user.role}</span>
            </div>
          )}
          <button type="button" className="btn btn-ghost" onClick={() => void logout()}>
            Log out
          </button>
        </header>
        <main id="main" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
